<svg
  class="icon-sign-out"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 20 20"
  [attr.fill]="color"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.1665 3.33333C3.94549 3.33333 3.73353 3.42113 3.57725 3.57741C3.42097 3.73369 3.33317 3.94565 3.33317 4.16667V15.8333C3.33317 16.0543 3.42097 16.2663 3.57725 16.4226C3.73353 16.5789 3.94549 16.6667 4.1665 16.6667H7.49984C7.96007 16.6667 8.33317 17.0398 8.33317 17.5C8.33317 17.9602 7.96007 18.3333 7.49984 18.3333H4.1665C3.50346 18.3333 2.86758 18.0699 2.39874 17.6011C1.9299 17.1323 1.6665 16.4964 1.6665 15.8333V4.16667C1.6665 3.50363 1.9299 2.86774 2.39874 2.3989C2.86758 1.93006 3.50346 1.66667 4.1665 1.66667H7.49984C7.96007 1.66667 8.33317 2.03976 8.33317 2.5C8.33317 2.96024 7.96007 3.33333 7.49984 3.33333H4.1665Z"
    [attr.fill]="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.7441 5.24408C13.0695 4.91864 13.5972 4.91864 13.9226 5.24408L18.0893 9.41074C18.4147 9.73618 18.4147 10.2638 18.0893 10.5893L13.9226 14.7559C13.5972 15.0814 13.0695 15.0814 12.7441 14.7559C12.4186 14.4305 12.4186 13.9028 12.7441 13.5774L16.3215 10L12.7441 6.42259C12.4186 6.09715 12.4186 5.56951 12.7441 5.24408Z"
    [attr.fill]="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.6665 10C6.6665 9.53976 7.0396 9.16667 7.49984 9.16667H17.4998C17.9601 9.16667 18.3332 9.53976 18.3332 10C18.3332 10.4602 17.9601 10.8333 17.4998 10.8333H7.49984C7.0396 10.8333 6.6665 10.4602 6.6665 10Z"
    [attr.fill]="color"
  />
</svg>
